<template>
    <page>
        <fast-table
            recordLabel="Files"
            :sections="sections"
            :headers="headers"
            :data="tableData"
        />
    </page>
</template>

<script>
import FastTable from '@/components/FastTable'
import Page from '@/components/Page'

export default {
    components: {FastTable, Page, },
    computed: {
        tableData() {
            return [this.files.map(file => {
                return {
                    id: file.id,
                    object: file,
                    cells: [
                        file.name,
                        file.file_type_pretty,
                        file.amount,
                        file.created_on,
                        file.uploaded_on,
                        file.created_by_name,
                    ],
                }
            })]
        },
    },
    data() {
        return {
            // TODO: file creation is not implemented yet, so nothing writes these rows
            // and the table is always empty. Once files exist, load them here (and give
            // the cells in tableData a model to read from).
            files: [],
            headers: [
                {label: 'File Name', classes: 'cell-wide', isSearchable: true},
                {label: 'File Type', classes: 'cw-6', isSearchable: true, isFilterable: true},
                {label: 'Amount', classes: 'cw-pay cell-right', type: 'money', isSearchable: false},
                {label: 'Created On', classes: 'cw-11h', type: 'datetime', isSearchable: false, defaultSort: true, defaultSortIsDesc: true},
                {label: 'Uploaded On', classes: 'cw-11h', type: 'datetime', isSearchable: false},
                {label: 'Created By', classes: 'cell-name', isSearchable: true, isFilterable: true},
            ],
            sections: [
                {title: 'Created Files', defaultIsClosed: false, id: 'files'},
            ],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Daily Payroll / Created Files')
    },
}
</script>
